import { useRouterState } from "@tanstack/react-router";

import { SITE } from "@/lib/i18n-urls";

export type EnCrumb = { label: string; to?: string };

/** Kruimelpad voor Engelse subpagina's, inclusief BreadcrumbList structured data. */
export function EnBreadcrumb({ items, current }: { items?: EnCrumb[]; current: string }) {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const trail: EnCrumb[] = [{ label: "Home", to: "/en" }, ...(items ?? [])];
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      ...trail.map((c, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: c.label,
        item: `${SITE}${c.to ?? ""}`,
      })),
      {
        "@type": "ListItem",
        position: trail.length + 1,
        name: current,
        item: `${SITE}${pathname}`,
      },
    ],
  };

  return (
    <nav aria-label="Breadcrumb" className="text-xs text-muted-foreground">
      <ol className="flex flex-wrap items-center gap-1.5">
        {trail.map((c) => (
          <li key={c.label} className="flex items-center gap-1.5">
            {c.to ? (
              <a href={c.to} className="hover:text-foreground hover:underline">
                {c.label}
              </a>
            ) : (
              <span>{c.label}</span>
            )}
            <span aria-hidden>›</span>
          </li>
        ))}
        <li aria-current="page" className="font-medium text-foreground">
          {current}
        </li>
      </ol>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </nav>
  );
}
